import type {PricedItemChange, PricedResourceType} from '../types/PricedItemChange';

export const removedItem = (
  resourceType: PricedResourceType,
  key: string,
  name: string,
  price: string
): PricedItemChange => ({
  resourceType,
  key,
  name,
  operation: 'removed',
  before: price,
  after: null,
});
